module.exports = __webpack_public_path__ + "img/page-24.542cec07.jpg";